/** Code of the send refusal whose `details.emptySamples` names the samples without analyses */
export const ORDER_SAMPLES_WITHOUT_ANALYSES = 'ORDER_SAMPLES_WITHOUT_ANALYSES';

/**
 * The backend drops the analyses associated to a sample that are no longer orderable (SMP-1612)
 * on every sample-analyses save and order send, and reports them so the customer can be told.
 */
export default {
  fromResponse: response => response?.data?.removedAnalyses ?? [],

  fromError: error => error?.response?.data?.error?.details?.removedAnalyses ?? [],

  notify(vm, removedAnalyses = [], samples = []) {
    if (!removedAnalyses.length) return false;
    const productName = id => samples.find(sample => sample.id === id)?.productName ?? id;
    const lines = removedAnalyses.map(analysis => vm.$t('orders.create.removedAnalysisLine', {
      code: analysis.analysisCode,
      description: analysis.analysisDescription,
      offer: analysis.offerDocNumber,
      sample: productName(analysis.sampleId),
    }));
    vm.$notify({
      showClose: true,
      type: 'warning',
      duration: 0,
      title: vm.$t('orders.create.removedAnalysesTitle'),
      message: lines.join(' · '),
    });
    return true;
  },

  errorMessage(vm, error) {
    const body = error?.response?.data?.error;
    const emptySamples = body?.details?.emptySamples ?? [];
    if (body?.code === ORDER_SAMPLES_WITHOUT_ANALYSES && emptySamples.length) {
      return vm.$t('orders.create.emptySamples', {
        samples: emptySamples.map(sample => sample.productName ?? sample.sampleId).join(', '),
      });
    }
    return body?.message;
  },
};
